import { SECTION_TYPES } from "@/lib/constants/sections";
import { HandCoins } from "lucide-react";

const offersSection = {
  type: SECTION_TYPES.OFFERS,
  content: {
    header: "Offers",
    isGlobal: true,
    offers: [
      {
        title: "Summer Discount",
        description:
          "Limited-time discount offer! Our expert landscaping team is offering an exclusive deal for new customers. Take advantage of our special discount and create the outdoor oasis you've always dreamed of. Act fast, this offer won't last forever!",
        amount: "$50 off your first service",
        discountCode: "SUMMER50",
        autoPopup: false,
      },
      {
        title: "First Time Cleaning Discount",
        description:
          "Limited-time discount offer! Our expert landscaping team is offering an exclusive deal for new customers. Take advantage of our special discount and create the outdoor oasis you've always dreamed of. Act fast, this offer won't last forever!",
        amount: "$100 off your first service",
        discountCode: "LAWN100",
        autoPopup: true,
      },
    ],
  },
  meta: {
    displayName: "Offers",
    displayDescription: "Offer your customers a call to action for printing.",
    displayIcon: HandCoins,
    variantsCount: 3,
  },
  aiPrompt() {
    return `In the Offers section, present the company's special offers, promotions, or packages in a clear and attractive manner. 
    Use persuasive language to highlight the value and benefits of each offer. 
    Make sure to include any relevant terms and conditions. 
    LIMIT THE DESCRIPTION TO 50 WORDS.`;
  },
};

export default offersSection;
